import {
  customerMarketShopfrontJobsApi,
  marketApi,
  Site
} from '@envato/foundation-types'
import * as React from 'react'

import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { config } from '../../../../common/config'
import { getCurrentSiteDomain } from '../../../../common/utils/sites'
import { IItem } from '../../../../typings/searchResults'
import { ISeoItem } from '../../../../typings/seoMetadata'
import Button from '../../../components/button'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../../components/imagePlaceholder'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import SectionDescription from '../sectionDescription'

import * as styles from './featuredAuthorSection.module.css'

const FeaturedAuthorSection = ({
  name,
  items,
  author,
  metadata,
  videoMuted,
  muteVideo,
  reportItemClick,
  currentSite
}: {
  name: string
  items: customerMarketShopfrontJobsApi.IItem[]
  author?: marketApi.IFeaturedAuthor
  metadata: ISeoItem
  videoMuted: boolean
  muteVideo: () => any
  reportItemClick: (
    index: number,
    item: customerMarketShopfrontJobsApi.IItem,
    listName: string
  ) => any
  currentSite: Site
}) => {
  const defaultAvatarImgSrc = `${
    config.assets.PUBLIC_PATH
  }/images/default-user.jpg`

  const avatarSrc = (author && author.profile_image_url) || defaultAvatarImgSrc

  return (
    <div data-test-selector="featuredAuthorSection" className={styles.root}>
      <SectionDescription metadata={metadata} HTag="h3" />
      {author && (
        <div className={styles.authorDisplay}>
          <div className={styles.authorInfo}>
            <div className={styles.authorAvatar}>
              <EnhancedLazyLoad
                placeholder={<ImagePlaceholder width={80} height={80} />}
              >
                <img
                  src={avatarSrc}
                  alt={author.username}
                  className={styles.authorAvatarImg}
                />
              </EnhancedLazyLoad>
            </div>
            <div className={styles.authorDescription}>
              <a
                href={`//${getCurrentSiteDomain(currentSite)}${
                  author.profile_path
                }`}
                className={styles.profileLink}
              >
                <h4>{author.username}</h4>
              </a>
              <p className={styles.descriptionNote}>
                {author.country && `${author.country}, `}Member since{' '}
                {author.member_since}
              </p>
              {author.portfolio_path && (
                <Button
                  type={Button.Type.Primary}
                  href={`//${getCurrentSiteDomain(currentSite)}${
                    author.portfolio_path
                  }`}
                  className={styles.button}
                  onClick={() =>
                    reportBlockClick('Featured Author', {
                      eventLabel: 'View portfolio'
                    })
                  }
                >
                  View portfolio
                </Button>
              )}
            </div>
          </div>
          <div className={styles.itemCarousel}>
            <ItemThumbnailCarousel justifyContent={'flex-end'}>
              {items.map((item, index) => {
                return (
                  <ItemPreviewer
                    item={item as IItem}
                    key={item.id}
                    videoMuted={videoMuted}
                    muteVideo={muteVideo}
                    lazyLoad={true}
                    onClick={() => reportItemClick(index, item, name)}
                  />
                )
              })}
            </ItemThumbnailCarousel>
          </div>
        </div>
      )}
    </div>
  )
}

export default FeaturedAuthorSection
